import { SET_LOADING } from "constants/action";

export const setLoading = (isShow: boolean) => ({
    type: SET_LOADING,
    isShow,
});
